import { render, staticRenderFns } from "./SystemLogsReport.vue?vue&type=template&id=30e1799c&"
import script from "./SystemLogsReport.vue?vue&type=script&lang=js&"
export * from "./SystemLogsReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports